/**
 * Infinite (looping) scrolling for the homepage collection tile carousels.
 * Clones the tiles before and after the originals; when scrolling stops in a
 * clone zone the scroll position silently jumps to the identical original zone.
 */
(function () {
  if (window.__vrLoopCarousel) {
    window.__vrLoopCarousel();
    return;
  }

  function setup(carousel) {
    if (document.dir === 'rtl') return;
    var slider = carousel.querySelector('.slider');
    var grid = carousel.querySelector('.slider__grid');
    if (!slider || !grid) return;

    var items = [].slice.call(grid.children).filter(function (el) {
      return el.classList.contains('slider__item');
    });
    if (items.length < 3 || items[0].offsetWidth === 0) return;

    var span = items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
    if (span <= 0) return;
    var perPage = Math.ceil(slider.clientWidth / span);
    if (items.length <= perPage) return;

    carousel.__vrLoop = true;

    function makeClone(el) {
      var c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('data-loop-clone', '');
      [].forEach.call(c.querySelectorAll('[id]'), function (n) { n.removeAttribute('id'); });
      [].forEach.call(c.querySelectorAll('a, button'), function (n) { n.setAttribute('tabindex', '-1'); });
      return c;
    }

    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    items.forEach(function (el) {
      before.appendChild(makeClone(el));
      after.appendChild(makeClone(el));
    });
    var firstClone = before.firstChild;
    grid.insertBefore(before, items[0]);
    grid.appendChild(after);

    var setWidth = items[0].getBoundingClientRect().left - firstClone.getBoundingClientRect().left;
    if (setWidth <= 0) return;

    // Keep the prev/next buttons always active (the theme disables them at the ends).
    carousel.setButtonStates = function () {
      if (this.prevBtn) this.prevBtn.disabled = false;
      if (this.nextBtn) this.nextBtn.disabled = false;
    };
    [].forEach.call(carousel.querySelectorAll('.slider-nav__btn'), function (b) { b.disabled = false; });

    var jumping = false;
    var touching = false;
    var timer = null;

    function jump(pos) {
      jumping = true;
      var snap = slider.style.scrollSnapType;
      var behavior = slider.style.scrollBehavior;
      slider.style.scrollSnapType = 'none';
      slider.style.scrollBehavior = 'auto';
      slider.scrollLeft = pos;
      requestAnimationFrame(function () {
        slider.style.scrollSnapType = snap;
        slider.style.scrollBehavior = behavior;
        setTimeout(function () { jumping = false; }, 60);
      });
    }

    function measure() {
      var w = items[0].getBoundingClientRect().left - firstClone.getBoundingClientRect().left;
      if (w > 0) setWidth = w;
    }

    function check() {
      if (touching || slider.classList.contains('is-grabbing')) {
        schedule();
        return;
      }
      var p = slider.scrollLeft;
      if (p < setWidth - 2) {
        jump(p + setWidth);
      } else if (p >= 2 * setWidth - 2) {
        jump(p - setWidth);
      }
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(check, 150);
    }

    slider.addEventListener('scroll', function () {
      if (jumping) return;
      schedule();
    }, { passive: true });
    slider.addEventListener('touchstart', function () { touching = true; }, { passive: true });
    slider.addEventListener('touchend', function () { touching = false; schedule(); }, { passive: true });
    slider.addEventListener('touchcancel', function () { touching = false; schedule(); }, { passive: true });
    slider.addEventListener('mouseup', schedule);
    slider.addEventListener('mouseleave', schedule);

    window.addEventListener('on:debounced-resize', function () {
      measure();
      jump(setWidth);
    });

    // Start on the original tiles (the middle set).
    jump(setWidth);
  }

  function run() {
    [].forEach.call(document.querySelectorAll('.collection-slider-row carousel-slider, .related-collection-links--gallery carousel-slider, .related-products carousel-slider'), function (c) {
      if (!c.__vrLoop) setup(c);
    });
  }

  window.__vrLoopCarousel = run;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
})();
